var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative photo"},[_c('b-img',{attrs:{"fluid":"","src":'https://images.eram.cat/slir/w400-c3x4/persona/' +
      _vm.inscr.persona_foto_foto}}),_c('h3',[_vm._v(_vm._s(_vm.inscr.persona_nom)),_c('br'),_vm._v(_vm._s(_vm.inscr.persona_cog1))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }